import React from "react";
import AppContext from "../services/appContext";
import MyNotifications from "../components/MyNotifications/MyNotifications";

const MyNotificationView = () => (
  <AppContext.Consumer>{({ user }) => <MyNotifications user={user} />}</AppContext.Consumer>
);

export default MyNotificationView;
